export default {
  "HitPaw Online Audio Converter": "HitPaw線上音檔轉換器",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "免費將音檔轉換為MP3, AAC, FLAC, WMA等影音檔格式。",
  'HitPaw Online Image Converter': 'HitPaw線上圖片轉換器',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': '免費將圖片轉換為JPG, PNG, BMP, TIFF等圖片格式。',
  'HitPaw Online Video Converter': '在线视频转格式',
  'Convert videos to any formats as your requirements.': '在线视频转格式描述',
  'Add More Files': '添加更多檔案',
  'Convert to': '轉為',
  'Ready': '準備',
  'Converting': '轉格式中',
  'Video': '影片',
  'Audio': '音檔',
  'Image': '圖片',
  'Retry': '重試',
  'Download All': '下載全部',
  'Download Desktop': '下载桌面端',
  'Continue Editing': '繼續編輯',
  'Convert': '轉格式',
  'Cut': '剪切',
  'Speed': '變速',
  'Crop & Rotate': '裁剪',
  'Resize': '改變大小',
  'Extract': '擷取音訊或影片',
  'Add Music': '加音樂',
  'Subtitles': '加字幕',
  'Merge': '合併',
  'Watermark Remover': '移除水印',
  'Add Watermark': '加水印',
  'Please select a file to use': '請選擇一個檔案去{{work}}',
  'Batch Processing': 'Batch Processing',
};
